import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/operations/very-low-risk-customers')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/operations/very-low-risk-customers']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
